import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import {
  ListItem as ListItemTextContainer,
} from '.';
import Headline5
  from '../Typography/Heading/Headline5';
import Body2
  from '../Typography/Body/Body2';
import breakpoints from '../Theme/breakpoints';
import grey from '../Palettes/grey';

const ListItem = styled.li`
  border-bottom: 1px solid ${grey[325]};
  margin: 0 16px;
  list-style-type: none;

  &:last-of-type {
    border-bottom: none;
  }

  @media (min-width: ${breakpoints.md}px) {
    margin: 0;
  }
`;

const listItemContentPropertyTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  imageLeft: PropTypes.node,
  imageRight: PropTypes.node,
  contentClassName: PropTypes.string,
  showDivider: PropTypes.bool,
};

type ListItemContentProperties = InferProps<
  typeof listItemContentPropertyTypes
> & {
  contentClassName?: string;
  showDivider?: boolean;
};

const ListItemContent = ({
  title,
  subtitle,
  description,
  imageLeft,
  imageRight,
  contentClassName,
  showDivider,
}: ListItemContentProperties) => (
  <ListItemTextContainer
    tag="div"
    showDivider={showDivider}
  >
    {imageLeft}
    <div className={contentClassName}>
      {title
      && (
      <Headline5 tag="h2">
        {title}
      </Headline5>
      )}
      {subtitle
      && (
      <Body2>
        {subtitle}
      </Body2>
      )}
      {description
      && (
      <Body2>
        {description}
      </Body2>
      )}
    </div>
    {imageRight}
  </ListItemTextContainer>
);

ListItemContent.propTypes = listItemContentPropertyTypes;

export { ListItem };

export default ListItemContent;
